module.exports = __webpack_public_path__ + "assets/img/w_d_i_11.26c7ca24.jpg";